<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Kelompok Barang</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="filter" name="filterTable"
                            id="filterInput"
                            type="search"
                            placeholder="Nama Kelompok"
                            @keyup.enter="onFilter(filter)" 
                        ></b-form-input>
                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter(filter)"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                    </div>
                </b-form-group>
                <div>
                    <b-button class="mb-3" variant="pgiBtn" @click="$bvModal.show('m-create')">Input Kelompok Barang</b-button>
                </div>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields" 
                :currentPage="currentPage" 
                :perPage="perPage"
                @filtered="onFiltered"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data kelompok barang.
                </template>
                <template v-slot:cell(adjustment)="row">
                    <div v-if="row.item.tipeNominal == 1"><!-- Persen -->
                        {{ $helper.addThousandSeparator(row.item.nominal) }}%
                    </div>
                    <div v-else-if="row.item.tipeNominal == 2"><!-- Nominal Angka -->
                        Rp. {{ $helper.addThousandSeparator(row.item.nominal) }}
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-button size="sm" class="mr-3 table-button edit" v-b-tooltip.hover title="Edit" @click="stageEdit(row.item)">
                            <i class="fa fa-pencil-square-o"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="m-create" title="Kelompok Barang Baru" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nama Kelompok">
                <b-input v-model="input.name" maxlength="100" />
            </b-form-group>
            <b-form-group label="Tipe Nominal">
                <b-form-radio-group
                    v-model="input.tipeNominal"
                    :options="optTipeNominal"
                />
            </b-form-group>
            <b-form-group v-if="input.tipeNominal == 1" label="Nominal Persen" 
                description="Contoh: -10% artinya pengurangan 10% dari harga dasar. 15% artinya penambahan 15% dari harga dasar"
            >
                <b-input-group append="%">
                    <b-input v-model="input.nominalPersen" maxlength="5" step="0.01" type="number" @blur="roundPersen" />
                </b-input-group>
            </b-form-group>
            <b-form-group v-else-if="input.tipeNominal == 2" label="Nominal Angka" 
                description="Contoh: Rp. -100.000 artinya pengurangan 100.000 dari harga dasar. Rp. 50.000 artinya penambahan 50.000 dari harga dasar"
            >
                <b-input-group prepend="Rp.">
                    <b-input v-model="input.nominalAngka" maxlength="20" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="pgiBtn" @click="prepare('m-confirm-create')">
                    Simpan
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit" title="Edit Kelompok Barang" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nama Kelompok">
                <b-input v-model="input.name" maxlength="100" />
            </b-form-group>
            <b-form-group label="Tipe Nominal">
                <b-form-radio-group
                    v-model="input.tipeNominal"
                    :options="optTipeNominal"
                />
            </b-form-group>
            <b-form-group v-if="input.tipeNominal == 1" label="Nominal Persen" 
                description="Contoh: -10% artinya pengurangan 10% dari harga dasar. 15% artinya penambahan 15% dari harga dasar"
            >
                <b-input-group append="%">
                    <b-input v-model="input.nominalPersen" maxlength="5" step="0.01" type="number" @blur="roundPersen" />
                </b-input-group>
            </b-form-group>
            <b-form-group v-else-if="input.tipeNominal == 2" label="Nominal Angka" 
                description="Contoh: Rp. -100.000 artinya pengurangan 100.000 dari harga dasar. Rp. 50.000 artinya penambahan 50.000 dari harga dasar"
            >
                <b-input-group prepend="Rp.">
                    <b-input v-model="input.nominalAngka" maxlength="20" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="pgiBtn" @click="prepare('m-confirm-edit')">
                    Simpan
                </b-button>
            </div>
        </b-modal>
        <ModalConfirm id="m-confirm-create" title="Confirm Kelompok Barang Baru" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput kelompok barang ini?" @submit="submitCreate" />
        <ModalConfirm id="m-confirm-edit" title="Confirm Edit Kelompok Barang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengedit kelompok barang ini?" @submit="submitEdit" />
    </div>
</template>

<script>    
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false, 

            input: {
                show: 10,
                name: "",
                nominalPersen: "",
                nominalAngka: "",
                tipeNominal: 1
            },
            fields: [
                { key: "name", label: "Kelompok Barang", sortable: true },
                { key: "adjustment", label: "Adjustment Harga Dasar", sortable: true },
                { key: "action", label: "Aksi"},
            ],
            filter: null,
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            itemsAll: [],
            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',

            optTipeNominal: [
                { text: "Persen", value: 1 },
                { text: "Nominal", value: 2 }
            ]

        }

    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init() {
            this.initStatus = 0

            let getKelompok = this.getKelompok()

            Promise.all([getKelompok]).then(() => {
                this.initStatus = 1
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        getKelompok() {

            return this.$axios.get("barang-kelompok/").then(response => {
                this.itemsAll = response.data
                this.items = response.data
                this.updateTotalItem()
            })

        },

        prepare(modalToShow) {

            if(this.input.name == "") {
                return this.$helper.toastErr(this, "Mohon mengisi nama!")
            }

            if(this.input.tipeNominal == 1 && this.$helper.isNullOrEmpty(this.input.nominalPersen)) {
                return this.$helper.toastErr(this, "Mohon mengisi nominal!")
            }

            if(this.input.tipeNominal == 2 && this.$helper.isNullOrEmpty(this.input.nominalAngka)) {
                return this.$helper.toastErr(this, "Mohon mengisi nominal!")
            }

            this.$bvModal.show(modalToShow)

        },

        submitCreate() {

            let payload = new FormData()
            payload.append("name", this.input.name)
            payload.append("tipeNominal", this.input.tipeNominal)

            if(this.input.tipeNominal == 1) {
                payload.append("nominal", this.input.nominalPersen)
            }
            else if(this.input.tipeNominal == 2) {
                payload.append("nominal", this.$helper.removeThousandSeparator(this.input.nominalAngka))
            }

            this.isSubmitting = true
            this.$axios.post("barang-kelompok/", payload).then(() => {

                this.$helper.toastSucc(this, "Barang kelompok berhasil ditambahkan!")
                this.$bvModal.hide("m-confirm-create")
                this.$bvModal.hide("m-create")

                this.input.name = ""
                this.input.tipeNominal = 1
                this.input.nominalPersen = ""
                this.input.nominalAngka = ""

                this.getKelompok()

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        stageEdit(item) {
            
            this.activeItem = item
            this.input.name = this.activeItem.name
            this.input.tipeNominal = this.activeItem.tipeNominal
            
            if(this.input.tipeNominal == 1) {
                this.input.nominalPersen = this.activeItem.nominal
            }
            else if(this.input.tipeNominal == 2) {
                this.input.nominalAngka = this.$helper.addThousandSeparator(this.activeItem.nominal)
            }

            this.$bvModal.show("m-edit")

        },

        submitEdit() {

            let payload = new FormData()
            payload.append("id", this.activeItem.id)
            payload.append("name", this.input.name)
            payload.append("tipeNominal", this.input.tipeNominal)

            if(this.input.tipeNominal == 1) {
                payload.append("nominal", this.input.nominalPersen)
            }
            else if(this.input.tipeNominal == 2) {
                payload.append("nominal", this.$helper.removeThousandSeparator(this.input.nominalAngka))
            }

            this.isSubmitting = true
            this.$axios.post("barang-kelompok/", payload).then(() => {

                this.$helper.toastSucc(this, "Barang kelompok berhasil diubah!")
                this.$bvModal.hide("m-confirm-edit")
                this.$bvModal.hide("m-edit")

                this.input.name = ""
                this.input.tipeNominal = 1
                this.input.nominalPersen = ""
                this.input.nominalAngka = ""

                this.getKelompok()

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------
        
        onPageChange() {
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onLimitChange() {
            this.perPage = this.input.show
            this.onPageChange()
        },

        onFilter(letters) {
            
            if(this.filter == null){
                this.$helper.toastErr(this, "Silakan isi nama kelompok barang terlebih dahulu!")
            }
            else{
                let filteredArray = []

                for (var x of this.itemsAll) {
                    if(x.name.toLowerCase().includes(letters.toLowerCase())){
                        filteredArray.push(x)
                    }
                }
                
                this.items = filteredArray
                this.onFiltered(this.items)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onReset(){
            this.filter = ""
            this.toggleBusy()
            this.items = this.itemsAll
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem() {
      
            this.rows = this.items.length
          
            // if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

        roundPersen() {
            var x = Number(this.input.nominalPersen).toFixed(2);
            this.input.nominalPersen = x;
        }

    },

    watch: {
        
        "input.nominalAngka": function(newVal) {

            let cleanValue = this.$helper.changeToValue(newVal)
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.$nextTick(() => this.input.nominalAngka = result)

        }

    },

    created() {
        this.init()
    }

}
</script>
